$(document).ready(function () {
  const mobileOnlySlider = ($slidername, $dots, $arrows, $breakpoint, $infinite, $fade) => {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      dots: $dots,
      infinite: $infinite,
      swipeToSlide: true,
      arrows: $arrows,
      fade: $fade,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick"
        }
      ]
    };
    slider.slick(settings);
    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  };
  mobileOnlySlider(".video-row", true, true, 767, false, false);
  mobileOnlySlider(".comparison-slider", true, true, 767, true, true);
});
